import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErInrPipe } from './inr.pipe';
import { ErStatusDotComponent } from './status-dot.component';
import { ErStatusPillComponent } from './status-pill.component';
import { ErKpiCardComponent } from './kpi-card.component';
import { ErEmptyStateComponent } from './empty-state.component';
import { ErErrorStateComponent } from './error-state.component';
import { ErSkeletonComponent } from './skeleton.component';
import { ErStepperComponent } from './stepper.component';

const KIT = [
  ErInrPipe,
  ErStatusDotComponent,
  ErStatusPillComponent,
  ErKpiCardComponent,
  ErEmptyStateComponent,
  ErErrorStateComponent,
  ErSkeletonComponent,
  ErStepperComponent
];

/**
 * EasyRin UI kit — presentational components + the erInr pipe.
 * No services, no HTTP, no state: safe to import anywhere without
 * touching business logic. Styling comes from src/styles/_kit.scss.
 */
@NgModule({
  declarations: [...KIT],
  imports: [CommonModule],
  exports: [...KIT]
})
export class UiKitModule { }
